let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1uhRX")).then(() => parcelRequire('3HAKZ'));